import { BiometryFlow, StartBiometryParams } from '../types'

class Biometry {
  private captchaValue: string
  private userCpf: string
  private callbackRoute: string
  private biometryFlow: BiometryFlow

  registerBiometryData({
    captcha,
    cpf,
    callbackRoute,
    biometryFlow,
  }: StartBiometryParams) {
    this.captchaValue = captcha
    this.userCpf = cpf
    this.callbackRoute = callbackRoute
    this.biometryFlow = biometryFlow
  }

  getBiometryData() {
    return {
      captcha: this.captchaValue,
      cpf: this.userCpf,
      callbackRoute: this.callbackRoute,
      biometryFlow: this.biometryFlow,
    }
  }
}

export default new Biometry()
